<script lang="ts">

    import { Component, Vue, Prop } from "vue-facing-decorator";
    import IconComponent from "@/components/atoms/Icon.vue";
    import { IconName, TranslationKey } from "webshop-modules";
    import { SearchResultItem } from "@/domain/main-header/entity/SearchResultItem.interface";

    @Component({
        components: {
            IconComponent
        }
    })
    export default class QuickSearchResults extends Vue {

        @Prop() public query!: string;
        @Prop() public results: any[] | null = null;
        @Prop() public searchParam!: string;
        @Prop() public searchUrl!: string;

        public readonly IconName: typeof IconName = IconName;
        public readonly Translation: typeof TranslationKey = TranslationKey;

        private updateSearch(item: SearchResultItem, event: Event) {
            if (!item.url) {
                event.preventDefault();
                this.$emit('updateSearch', item.title, this.results);
            }
        }
    }
</script>

<template>
    <div class="m-quickSearchResults" v-if="results">
        <template v-if="results.length > 0">
            <ul class="m-quickSearchResults__suggestionList">
                <li v-for="(item, idx) in results" :key="idx" class="m-quickSearchResults__suggestionListItem">
                    <a :href="item.url" @click="updateSearch(item, $event)">
                        <span class="m-quickSearchResults__suggestionListItemIcon">
                            <template v-if="item.type === 'search'">
                                <IconComponent :icon-id="IconName.Search"/>
                            </template>
                            <template v-else>
                                <IconComponent :icon-id="IconName.Calendar"/>
                            </template>
                        </span>
                        <span class="m-quickSearchResults__suggestionListItemText" v-html="item.title"></span>
                    </a>
                </li>
            </ul>
            <a class="a-btnCta -action"
               :href="searchUrl + '?' + searchParam + '=' + query"
               v-translate="{ key: Translation.More_search_results }"
            ></a>
        </template>
        <p v-else-if="results.length === 0" class="m-quickSearchResults__empty" v-translate="{ key: Translation.No_search_results }"></p>
    </div>
</template>
